const styles = theme => ({
  close: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  }
});

export default styles;
